import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import parentApi from "../../services/parentApi";

const ParentContext = createContext(null);

export function ParentProvider({ children }) {
  const [kids, setKids]           = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading]     = useState(true);

  const fetchChildren = useCallback(async () => {
    setLoading(true);
    try {
      const res = await parentApi.get("/api/parent/children");
      const list = res.data?.data || [];
      setKids(list);
      setSelectedId((prev) => prev || list[0]?._id || null);
    } catch {
      setKids([]);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchChildren(); }, [fetchChildren]);

  const selectedChild = kids.find((k) => k._id === selectedId) || null;

  return (
    <ParentContext.Provider value={{ kids, selectedId, setSelectedId, selectedChild, loading, refetch: fetchChildren }}>
      {children}
    </ParentContext.Provider>
  );
}

export const useParentContext = () => useContext(ParentContext);
